import { HttpClient } from "../services";

const httpClient = new HttpClient();

type RevalidationResponse = { timestamp: number } & (
	| { revalidated: true }
	| { revalidated: false; error: Error }
);

export const revalidate = async (tag: string): Promise<RevalidationResponse> =>
	httpClient.get(`/api/revalidate?tag=${tag}`);
